"use strict";

exports.__esModule = true;

require('./content.css');

exports.default = {
  "content": "pf-c-content",
  "modifiers": {
    "overpassFont": "pf-m-overpass-font"
  }
};